const CONFIG = {
    DEFAULT_VERSION: '-1',
    VERSION: '0.0.342',
    CACHE_NAME: 'rmw-user-cache',
    // KILLSWITCH: set this to true to remove service worker and current cache storage
    CLEAR_CACHE_STORAGE: false,
};

export default CONFIG;
